import React from 'react';

/*eslint-disable */

var questionWithCircleIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    width: "20px",
    height: "20px",
    focusable: "false",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: "2",
    fill: "none",
    x: "1",
    y: "1",
    width: "18",
    height: "18",
    rx: "9",
    className: "manulifeIconSecondary-stroke"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 4.000000)",
    fillRule: "nonzero",
    strokeWidth: "0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6,8.9 L5.4,8.9 L5.4,11 L2.6,11 L2.6,8.9 Z M4.6031275,0.563222235 C5.66553999,0.721777155 6.5645044,1.35599684 7.09571065,2.30732636 C7.99467507,3.93251429 7.34088276,5.95408953 5.66553999,6.82614159 C5.42036787,6.94505778 5.2569198,7.18289016 5.21605778,7.42072254 L5.21605778,7.5 L2.76433664,7.5 L2.76433664,7.42072254 C2.80519866,6.27119937 3.45899097,5.24059239 4.48054144,4.72528889 C4.84829961,4.52709524 5.0526097,4.09106921 4.97088567,3.69468191 C4.88916163,3.29829461 4.56226548,2.98118477 4.15364529,2.90190731 C4.07192125,2.90190731 4.03105923,2.90190731 3.94933519,2.90190731 C3.41812895,2.90190731 2.96864674,3.33793334 2.96864674,3.85323683 L0.516925602,3.85323683 C0.476063583,3.65504318 0.516925602,3.4172108 0.557787621,3.21901715 C0.925545792,1.39563557 2.72347462,0.206473664 4.6031275,0.563222235 Z"
  }))));
});

export default questionWithCircleIcon;
